export default __webpack_public_path__ + "static/media/tutorial_robot_left@2x.45715124.png";